export default __webpack_public_path__ + "static/media/shield.3ac04bbc.svg";